<template>
  <div class="layout-container">
    <!-- 侧边栏 -->
    <el-container class="main-layout">
      <el-aside width="200px" class="sidebar">
        <div class="logo">
          <h2>学习管理后台</h2>
        </div>
        <el-menu
          :default-active="activeMenu"
          background-color="#304156"
          text-color="#bfcbd9"
          active-text-color="#409EFF"
          router
        >
          <el-menu-item index="/">
            <i class="el-icon-s-home"></i>
            <span>仪表盘</span>
          </el-menu-item>
          <el-menu-item index="/category-manage">
            <i class="el-icon-folder"></i>
            <span>栏目管理</span>
          </el-menu-item>
          <el-menu-item index="/video-manage">
            <i class="el-icon-reading"></i>
            <span>学习内容</span>
          </el-menu-item>
          <el-menu-item index="/quiz-manage">
            <i class="el-icon-edit-outline"></i>
            <span>测验管理</span>
          </el-menu-item>
          <el-menu-item index="/user-manage">
            <i class="el-icon-user"></i>
            <span>用户管理</span>
          </el-menu-item>
          <el-menu-item index="/inspect-manage">
            <i class="el-icon-warning-outline"></i>
            <span>隐患排查</span>
          </el-menu-item>
          <el-menu-item index="/study-records">
            <i class="el-icon-notebook-2"></i>
            <span>学习记录</span>
          </el-menu-item>
          <el-menu-item index="/checkin-manage">
            <i class="el-icon-camera"></i>
            <span>签到记录</span>
          </el-menu-item>
        </el-menu>
      </el-aside>

      <!-- 主内容区 -->
      <el-container class="content-container">
        <el-header class="header">
          <div class="header-left">
            <el-breadcrumb separator="/">
              <el-breadcrumb-item v-for="item in breadcrumb" :key="item.path">
                {{ item.meta.title || item.name }}
              </el-breadcrumb-item>
            </el-breadcrumb>
          </div>
          <div class="header-right">
            <el-dropdown @command="handleCommand">
              <span class="user-info">
                <el-avatar :src="user?.avatar || 'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png'" size="small"></el-avatar>
                <span class="username">{{ user?.name || '管理员' }}</span>
                <i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="profile">个人中心</el-dropdown-item>
                <el-dropdown-item command="logout">退出登录</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </el-header>

        <el-main class="main-content">
          <router-view></router-view>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'AdminLayout',
  computed: {
    ...mapState(['user']),
    activeMenu() {
      return this.$route.path
    },
    breadcrumb() {
      const matched = this.$route.matched.filter(item => item.meta && item.meta.title)
      return matched
    }
  },
  methods: {
    handleCommand(command) {
      if (command === 'logout') {
        this.$confirm('确定要退出登录吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          localStorage.removeItem('admin-token')
          this.$router.push('/login')
        }).catch(() => {})
      } else if (command === 'profile') {
        this.$message.info('当前登录用户：管理员')
      }
    }
  }
}
</script>

<style scoped>
.layout-container {
  height: 100vh;
}

.main-layout {
  display: flex;
  height: 100%;
  overflow: hidden;
}

.sidebar {
  background-color: #304156;
  height: 100%;
  overflow-y: auto;
}

.logo {
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  background-color: #2b3a4a;
}

.logo h2 {
  font-size: 18px;
  margin: 0;
}

.el-menu {
  border-right: none;
}

.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #fff;
  border-bottom: 1px solid #e6e6e6;
  padding: 0 20px;
  height: 60px;
}

.content-container {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  overflow: hidden;
}

.header-left {
  display: flex;
  align-items: center;
}

.header-right {
  display: flex;
  align-items: center;
}

.user-info {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.username {
  margin-left: 8px;
  margin-right: 4px;
}

.main-content {
  background-color: #f0f2f5;
  padding: 20px;
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
}
</style>